import { axiosInstance } from '../Config/axios';

export function getTenantFromHostname() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    return 'public';
  }
  const parts = hostname.split('.');
  if (parts.length >= 2 && parts[1] === 'localhost') {
    return parts[0];
  }
  if (hostname === 'eacc.exaamericas.com') {
    return 'eaccadmin';
  }
  if (parts.length > 2) {
    return parts[0];
  }
  return 'public';
}

export async function handleOpenFile(urlPath, type = 'file') {
  if (!urlPath) return null;

  try {
    const baseUrl = axiosInstance.defaults.baseURL.replace(/\/api\/?$/, '');
    const cleanPath = urlPath.replace(/^\/+/, '');
    const fullUrl = `${baseUrl}/${cleanPath}`;
    const token = localStorage.getItem('access_token');

    const response = await fetch(fullUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error(`Error al obtener recurso: ${response.status}`);

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    if (type === 'file') {
      // Abrir en nueva pestaña
      window.open(blobUrl, '_blank');
      return null; // no necesitamos devolver nada para files
    } else {
      // Para imágenes, devolver la URL para renderizar
      return blobUrl;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}